// A round top for the scale (1, 2, 5, 10, 20, 25, 50, ...) so gridlines land on whole numbers.
export function niceMax(n: number): number {
  if (n <= 4) return 4;
  const pow = 10 ** Math.floor(Math.log10(n));
  for (const step of [1, 2, 2.5, 5, 10]) if (step * pow >= n) return step * pow;
  return 10 * pow;
}
